<template>
    <div>
        <modal class="new-accounting" :display="modalStatus.newAccounting" @modalStatus="closeModal" >
            <h1>新增記帳</h1>
            <div class="new-accounting-wrap" :key="'height'+componentKey" v-bind:style="{'height': modalHeight}">
                <div class="input-wrap">
                    <span>選擇房源</span>
                    <rent-select-house :key="componentKey" :class="{error: error.newAccounting.houseCid}" refName="house" :selectMsg="seletcMsg.house" class="select-scroll" @getId="getSelectId" :setDefault="isDefault">
                        <ul>
                            <div class="house-filter">
                                <img class="search" src="@/assets/img/icon/search_gray.svg" alt="">
                                <input v-model="selectHouse" placeholder="搜尋地點、房源名稱" type="text">
                            </div>
                            <li ref="houseItem" @click="$root.$emit('house-item', selectHouseName(index))"  :data-id="item.cid" :data-name="item.address" v-for="(item, index) in filterHouse" :key="index">
                                <span class="name" :data-id="item.cid" :data-name="item.address" >{{item.houseName}}</span>
                                <span class="address" :data-id="item.cid" :data-name="item.address" >
                                    <img src="@/assets/img/icon/address_gray.svg" alt="">
                                    {{item.address}}
                                </span>
                            </li>
                        </ul>
                    </rent-select-house>
                    <span v-show="error.newAccounting.houseCid" class="error">{{error.newAccounting.houseCid}}</span>
                </div>
                <div class="input-wrap">
                    <span>選擇收支</span>
                    <rent-select :class="{error: error.newAccounting.type}" refName="type" :selectMsg="seletcMsg.billType" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="seletcMsg.isDefault">
                        <ul>
                            <li data-id="INCOME">
                                收入
                            </li>
                            <li data-id="EXPENSE">
                                支出
                            </li>
                        </ul>
                    </rent-select>
                    <span v-show="error.newAccounting.type" class="error">{{error.newAccounting.type}}</span>
                </div>
                <div class="input-wrap">
                    <span>記帳項目</span>
                    <div class="input-error-group">
                        <input :class="{error: error.newAccounting.billName}" type="text" v-model="newAccounting.billName" placeholder="例如：廣告費用">
                    </div>
                    <span v-show="error.newAccounting.billName" class="error">{{error.newAccounting.billName}}</span>
                </div>
                <div class="input-wrap">
                    <span>總金額</span>
                    <div class="input-error-group">
                        <input :class="{error: error.newAccounting.price}" type="text" v-model="newAccounting.price" placeholder="例如：6000" >
                    </div>
                    <span v-show="error.newAccounting.price" class="error">{{error.newAccounting.price}}</span>
                </div>
                <div class="input-wrap">
                    <span>記帳時間</span>
                    <div class="input-error-group">
                        <date-picker v-model="newAccounting.billDate" :class="{'active': newAccounting.billDate != null, 'error': error.newAccounting.billDate}" placeholder="請選擇記帳時間" value-type="YYYY-MM-DD" format="YYYY.MM.DD"></date-picker>
                    </div>
                    <span v-show="error.newAccounting.billDate" class="error">{{error.newAccounting.billDate}}</span>
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button confirm" @click="checkInput()">新增</button>
                <button class="border-button reject" @click="closeModal">取消</button>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import RentSelectHouse from '@/components/widge/RentSelectHouse.vue';
import RentSelect from '@/components/widge/RentSelect.vue';
import DatePicker from 'vue2-datepicker';
import { mapGetters } from 'vuex'

import { 
    apiGetHouseMgtList,
    apiAddOrUpdateLedger
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            modalHeight: (window.innerHeight-300) + 'px',
            componentKey: 0,
            newAccounting: {
                houseCid: '',
                type: '',
                billName: '',
                price: null,
                billDate: null
            },
            error: {
                newAccounting:{
                    houseCid: '',
                    type: '',
                    billName: '',
                    price: null,
                    billDate: null
                }
            },
            houseName: '請選擇',
            houseList: [],
            selectHouse: null,
            isDefault: false,
            seletcMsg: {
                house: '請選擇房源',
                billType: '請選擇收支',
                isDefault: false
            }
        }
    },
    mounted (){
        // this.$analytics.logEvent('新增費用_所有房源', { screen_name: '新增費用_所有房源'})
        this.getHouseList()
        window.addEventListener('resize', this.resizeModal)
    },
    destroyed() {
        window.removeEventListener('resize', this.resizeModal)
    },
    watch: {
        newAccounting: {
            handler: function (val) {
                if(val.houseCid){
                    this.error.newAccounting.houseCid = ''
                }
                if(val.billName){
                    this.error.newAccounting.billName = ''
                }
                if(val.type){
                    this.error.newAccounting.type = ''
                }
                if(val.billDate){
                    this.error.newAccounting.billDate = ''
                }
                if(val.price){
                    if(this.checkIsNum(val.price)){
                        this.error.newAccounting.price = ''
                    }else{
                        this.error.newAccounting.price = '請填寫數字'
                    }
                }
            },
            deep: true
        },
        'newAccounting.houseCid': function (val) {
            this.isDefault = false
        },
        // 'modalStatus.newAccounting': function (val) {
        //     if(val){
        //         this.$analytics.logEvent('新增記帳', { screen_name: '新增記帳'})
        //     }
        // }
    },
    methods: {
        resizeModal: function (){
            let _self = this
            console.log(window.innerHeight)
            if( window.innerHeight > 610){
                _self.modalHeight = (window.innerHeight-300) + 'px'
                _self.componentKey += 1
            }
        },
        getSelectId: function (value) {
            // console.log(value)
            if( value.ref == 'house' ){
                this.newAccounting.houseCid = value.id
                this.seletcMsg.isDefault = true
                this.newAccounting.billDate = null
            }else if ( value.ref == 'type' ){
                this.newAccounting.type = value.id
                this.seletcMsg.isDefault = false
            }
        },
        addNewAccounting: function () {
            this.$analytics.logEvent('送出新增記帳', { screen_name: '送出新增記帳'})
            let data = {
                houseCid: this.newAccounting.houseCid,
                ledgerType: this.newAccounting.type,
                ledgerItemName: this.newAccounting.billName,
                amount: this.newAccounting.price,
                recordingDate: this.newAccounting.billDate
            }
            // console.log(data)
            apiAddOrUpdateLedger(data)
            .then(res => {
                // console.log(res)
                if( res.data.status == "SUCCESS" ){
                    // console.log(res)
                    this.$store.dispatch('getAccountingBookMgtList')
                    this.closeModal()
                }
            })
            .catch(err => {
                // reject(err)
            })
        },
        closeModal: function (type) {
            this.$store.dispatch('setModalStatus', {state: false, type: 'newAccounting'})
            this.newAccounting = {
                houseCid: '',
                type: '',
                billName: '',
                price: '',
                billDate: ''
          
            }
            this.error.newAccounting = {
                houseCid: '',
                type: '',
                billName: '',
                price: '',
                billDate: ''
            }
            this.isDefault = true
            this.componentKey += 1
        },
        getHouseList: function () {
            apiGetHouseMgtList()
            .then(res => {
                // console.log(res)
                if( res.data.status == "SUCCESS" ){
                    if( res.data.result.houseList.length > 0){
                        this.houseList = res.data.result.houseList
                    }
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        selectHouseName: function (index) {
            // console.log(this.$refs.houseItem)
            // console.log(this.$refs.houseItem[index].children[0].innerText)
            // console.log(event)
            return this.$refs.houseItem[index].children[0].innerText
        },
        checkIsNum: function (num) {
            let numerical = /^[0-9]*$/
            return numerical.test(num)?true:false
        },
        checkInput: function () {
            if(!this.newAccounting.billName){
                this.error.newAccounting.billName = '請填寫帳單名稱'
            }else{
                this.error.newAccounting.billName = ''
            }

            if(!this.newAccounting.price){
                this.error.newAccounting.price = '請填寫金額'
            }else{
                this.error.newAccounting.price = ''
            }
            if(!this.newAccounting.houseCid){
                this.error.newAccounting.houseCid = '請選擇房源'
            }else{
                this.error.newAccounting.houseCid = ''
            }
            if(!this.newAccounting.billDate){
                this.error.newAccounting.billDate = '請選擇記帳時間'
            }else{
                this.error.newAccounting.billDate = ''
            }
            if(!this.newAccounting.type){
                this.error.newAccounting.type = '請選擇收支'
            }else{
                this.error.newAccounting.type = ''
            }
            if(
                this.newAccounting.billName &&
                this.newAccounting.type &&
                this.newAccounting.houseCid &&
                this.newAccounting.price &&
                this.newAccounting.billDate
            ){
                this.addNewAccounting()
            }
        },
        checkHouse: function () {
            if(!this.newAccounting.contractCid){
                this.error.newAccounting.houseCid = '請先選擇房源'
            }else{
                this.error.newAccounting.houseCid = ''
            }
        }
    },
    computed: {
        filterHouse: function () {
            return this.houseList.filter((house) => {
                if( this.selectHouse ){
                    if(house.address.includes(this.selectHouse)){
                        return house
                    }
                }else{
                    return house
                }
            });
        },
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
        RentSelectHouse,
        RentSelect,
        DatePicker
    }
}
</script>
<style lang="scss"  >
    #modal.new-accounting{
        .error{
            right: 0px;
            top: 7px;
        }
        .modal-content{
            width: 448px;
            padding: 0 !important;
            .detail{
                >h1{
                    margin-top: 32px;
                    margin-bottom: 24px;
                }
                .new-accounting-wrap{
                    padding: 0 32px 0 32px;
                    overflow-x: hidden;
                    max-height: 490px;
                    &::-webkit-scrollbar {
                        display: none;
                    }
                    .input-wrap{
                        position: relative;
                        margin-bottom: 24px;
                        >span{
                            display: block;
                            margin-bottom: 12px;
                        }
                        >.input-error-group{
                            >input{
                                width: 352px;
                            }
                        }
                    }
                    .mx-datepicker{
                        width: 384px;
                        input{
                            height: 46px;
                            border-radius: 4px;
                            border: solid 1px #e0dfde;
                            color: #a8a5a4;
                            padding: 13px 16px;
                            box-shadow: none;
                            margin-bottom: 0px;
                        }
                        .mx-icon-calendar,
                        .mx-icon-clear{
                            right: 14px;
                        }
                    }
                    .mx-datepicker.error{
                        input{
                            border: solid 1px #fc7171 !important;
                        }
                    }
                    .mx-datepicker:hover,
                    .mx-datepicker.active{
                        ::-webkit-input-placeholder { color: #676362; }
                        input::-moz-placeholder{
                            color:#676362;
                        }
                        input{
                            border: 1px solid #676362 ;
                            color: #676362 !important;
                        }
                        i{
                            color: #676362;
                        }
                    }
                    span.error {
                        right: 0;
                        top: 3px;
                        left: unset;
                        bottom: unset;
                    }
                    
                }
            }
            
            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                margin: 0 auto;
                button{
                    width: 184px;
                    height: 44px;
                }
                button.confirm{
                    margin-right: 16px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/NewAccounting.vue